module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-diff-c29d1b30.svg";